<form [formGroup]="parentForm">
  <!-- Common Fields -->
  <div *ngIf="commonFormSections?.length > 0" class="common-form-container">
    <div *ngIf="!hideOrderFormTitle" class="common-form-header mat-mdc-card display">
      <span>
        {{ 'FRONTEND.STORE.ORDER_FORM.LABELS.COMMON_FORM_HEADER_TITLE' | translate }}
      </span>
      <span class="common-form-header-text">
        {{ 'FRONTEND.STORE.ORDER_FORM.LABELS.COMMON_FORM_HEADER_TEXT' | translate }}
      </span>
    </div>
    <store-dropdown-form-section
      *ngFor="let formSection of commonFormSections"
      [parentForm]="parentForm"
      [prepopulatedData]="formSection.populatedData"
      [fields]="formSection.fields"
      [displayAutoTitle]="!orderFormOptions.readOnly"
      [titleText]="formSection.sectionName | translate"
      [startOpen]="dropdownOpen$ | async"
      [editingHint]="'FRONTEND.STORE.ORDER_FORM.LABELS.COMMON_FORM_EDITING_HINT' | translate"
    ></store-dropdown-form-section>
    <ng-container *ngIf="extraFieldsSection">
      <store-dropdown-form-section
        [parentForm]="parentForm"
        [prepopulatedData]="extraFieldsSection.prepopulatedData"
        [fields]="extraFieldsSection.fields"
        [displayAutoTitle]="!orderFormOptions.readOnly"
        [displayAutoDescription]="false"
        [startOpen]="true"
        [titleText]="'FRONTEND.STORE.ADMINISTRATIVE_QUESTIONS' | translate"
      ></store-dropdown-form-section>
    </ng-container>
  </div>

  <!--Custom Fields-->
  <ng-container *ngIf="customFormSections">
    <div *ngIf="customFormSections.length > 0" class="custom-form-container">
      <store-order-form-section
        *ngFor="let sectionData of customFormSections"
        [data]="sectionData"
        [extraHeaderContent]="extraHeaderContent"
        [bottomActionsContent]="bottomActionsContent"
      ></store-order-form-section>
    </div>
  </ng-container>
</form>
